// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const formItems = [
        {
            label: "校区",
            span: 24,
            placeholder: '请输入姓名',
            model: "campusName",
            labelClass: 'info-label'
        },
        {
            label: "宿舍区",
            span: 24,
            placeholder: '请选择性别',
            model: "areaName",
            labelClass: 'info-label'
        },
        {
            label: "楼栋",
            span: 24,
            model: "buildingName",
            labelClass: 'info-label'
        },
        {
            label: "楼层",
            span: 24,
            model: "floor",
            labelClass: 'info-label'
        },
        {
            label: "房间类型",
            span: 24,
            model: "typeName",
            labelClass: 'info-label'
        },
        {
            label: "房间号",
            span: 24,
            model: "houseName",
            labelClass: 'info-label'
        },
        {
            label: "床位",
            span: 24,
            model: "bedName",
            labelClass: 'info-label'
        },
        // {
        //     label: "入住时间",
        //     span: 24,
        //     model: "checkinTime",
        //     labelClass: 'info-label'
        // },
    ]
    return {
        formItems,
    }
}
